import { createAsyncAction } from 'redux-promise-middleware-actions';
import api from '../Api/apiIS';
import { getActionTypesResult } from '../utils';

export const myAssetsConstants = {
    MY_ASSETS_DEVICE_LOADED: 'MY_ASSETS_DEVICE_LOADED',
    MY_ASSETS_MOBILE_DEVICE_LOADED: 'MY_ASSETS_MOBILE_DEVICE_LOADED',
    MY_ASSETS_RESERVATION_LOADED: 'MY_ASSETS_RESERVATION_LOADED',
    MY_ASSETS_LICENSE_LOADED: 'MY_ASSETS_LICENSE_LOADED',
    MY_ASSETS_TRANSITION_LOADED: 'MY_ASSETS_TRANSITION_LOADED',
};

export const myAssetsFulfilledConstants = getActionTypesResult(myAssetsConstants, '_FULFILLED');
export const myAssetsPendingConstants = getActionTypesResult(myAssetsConstants, '_PENDING');
export const myAssetsRejectedConstants = getActionTypesResult(myAssetsConstants, '_REJECTED');

export const fetchMyAssetsDevice =
    createAsyncAction(myAssetsConstants.MY_ASSETS_DEVICE_LOADED, query =>
        api.get('user/current/equipment/devices', { params: query, paramsSerializer: { indexes: null } }).then(res => res.data)
    );
export const fetchMyAssetsMobileDevice =
    createAsyncAction(myAssetsConstants.MY_ASSETS_MOBILE_DEVICE_LOADED, query =>
        api.get('user/current/equipment/mobileDevices', { params: query, paramsSerializer: { indexes: null } }).then(res => res.data)
    );
export const fetchMyAssetsReservedDevice =
    createAsyncAction(myAssetsConstants.MY_ASSETS_RESERVATION_LOADED, query =>
        api.get('user/current/equipment/devices/reserved', { params: query, paramsSerializer: { indexes: null } }).then(res => res.data)
    );
export const fetchMyAssetsTransitedDevice =
    createAsyncAction(myAssetsConstants.MY_ASSETS_TRANSITION_LOADED, query =>
        api.get('user/current/equipment/devices/transited', { params: query, paramsSerializer: { indexes: null } }).then(res => res.data)
    );
export const fetchMyAssetsLicense =
    createAsyncAction(myAssetsConstants.MY_ASSETS_LICENSE_LOADED, query =>
        api.get('user/current/equipment/licenses', { params: query, paramsSerializer: { indexes: null } }).then(res => res.data)
    );
